// ISO 3166-1 alpha-2 codes (lowercase, for flagcdn.com) with PT/EN names.
// Used for the user nationality selector and flag rendering across the app.
const RAW = [
  { code: "af", pt: "Afeganistão", en: "Afghanistan" },
  { code: "za", pt: "África do Sul", en: "South Africa" },
  { code: "al", pt: "Albânia", en: "Albania" },
  { code: "de", pt: "Alemanha", en: "Germany" },
  { code: "ad", pt: "Andorra", en: "Andorra" },
  { code: "ao", pt: "Angola", en: "Angola" },
  { code: "ai", pt: "Anguila", en: "Anguilla" },
  { code: "ag", pt: "Antígua e Barbuda", en: "Antigua and Barbuda" },
  { code: "sa", pt: "Arábia Saudita", en: "Saudi Arabia" },
  { code: "dz", pt: "Argélia", en: "Algeria" },
  { code: "ar", pt: "Argentina", en: "Argentina" },
  { code: "am", pt: "Arménia", en: "Armenia" },
  { code: "au", pt: "Austrália", en: "Australia" },
  { code: "at", pt: "Áustria", en: "Austria" },
  { code: "az", pt: "Azerbaijão", en: "Azerbaijan" },
  { code: "bs", pt: "Bahamas", en: "Bahamas" },
  { code: "bh", pt: "Bahrein", en: "Bahrain" },
  { code: "bd", pt: "Bangladesh", en: "Bangladesh" },
  { code: "bb", pt: "Barbados", en: "Barbados" },
  { code: "be", pt: "Bélgica", en: "Belgium" },
  { code: "bz", pt: "Belize", en: "Belize" },
  { code: "bj", pt: "Benim", en: "Benin" },
  { code: "bm", pt: "Bermudas", en: "Bermuda" },
  { code: "by", pt: "Bielorrússia", en: "Belarus" },
  { code: "bo", pt: "Bolívia", en: "Bolivia" },
  { code: "ba", pt: "Bósnia e Herzegovina", en: "Bosnia and Herzegovina" },
  { code: "bw", pt: "Botsuana", en: "Botswana" },
  { code: "br", pt: "Brasil", en: "Brazil" },
  { code: "bn", pt: "Brunei", en: "Brunei" },
  { code: "bg", pt: "Bulgária", en: "Bulgaria" },
  { code: "bf", pt: "Burquina Faso", en: "Burkina Faso" },
  { code: "bi", pt: "Burundi", en: "Burundi" },
  { code: "bt", pt: "Butão", en: "Bhutan" },
  { code: "cv", pt: "Cabo Verde", en: "Cape Verde" },
  { code: "cm", pt: "Camarões", en: "Cameroon" },
  { code: "kh", pt: "Camboja", en: "Cambodia" },
  { code: "ca", pt: "Canadá", en: "Canada" },
  { code: "qa", pt: "Catar", en: "Qatar" },
  { code: "kz", pt: "Cazaquistão", en: "Kazakhstan" },
  { code: "td", pt: "Chade", en: "Chad" },
  { code: "cl", pt: "Chile", en: "Chile" },
  { code: "cn", pt: "China", en: "China" },
  { code: "cy", pt: "Chipre", en: "Cyprus" },
  { code: "co", pt: "Colômbia", en: "Colombia" },
  { code: "km", pt: "Comores", en: "Comoros" },
  { code: "cg", pt: "Congo", en: "Congo" },
  { code: "cd", pt: "Congo (RD)", en: "Congo (DRC)" },
  { code: "kp", pt: "Coreia do Norte", en: "North Korea" },
  { code: "kr", pt: "Coreia do Sul", en: "South Korea" },
  { code: "ci", pt: "Costa do Marfim", en: "Ivory Coast" },
  { code: "cr", pt: "Costa Rica", en: "Costa Rica" },
  { code: "hr", pt: "Croácia", en: "Croatia" },
  { code: "cu", pt: "Cuba", en: "Cuba" },
  { code: "dk", pt: "Dinamarca", en: "Denmark" },
  { code: "dj", pt: "Djibuti", en: "Djibouti" },
  { code: "dm", pt: "Dominica", en: "Dominica" },
  { code: "eg", pt: "Egito", en: "Egypt" },
  { code: "sv", pt: "El Salvador", en: "El Salvador" },
  { code: "ae", pt: "Emirados Árabes Unidos", en: "United Arab Emirates" },
  { code: "ec", pt: "Equador", en: "Ecuador" },
  { code: "er", pt: "Eritreia", en: "Eritrea" },
  { code: "sk", pt: "Eslováquia", en: "Slovakia" },
  { code: "si", pt: "Eslovénia", en: "Slovenia" },
  { code: "es", pt: "Espanha", en: "Spain" },
  { code: "us", pt: "Estados Unidos", en: "United States" },
  { code: "ee", pt: "Estónia", en: "Estonia" },
  { code: "sz", pt: "Essuatíni", en: "Eswatini" },
  { code: "et", pt: "Etiópia", en: "Ethiopia" },
  { code: "fj", pt: "Fiji", en: "Fiji" },
  { code: "ph", pt: "Filipinas", en: "Philippines" },
  { code: "fi", pt: "Finlândia", en: "Finland" },
  { code: "fr", pt: "França", en: "France" },
  { code: "ga", pt: "Gabão", en: "Gabon" },
  { code: "gm", pt: "Gâmbia", en: "Gambia" },
  { code: "gh", pt: "Gana", en: "Ghana" },
  { code: "ge", pt: "Geórgia", en: "Georgia" },
  { code: "gi", pt: "Gibraltar", en: "Gibraltar" },
  { code: "gd", pt: "Granada", en: "Grenada" },
  { code: "gr", pt: "Grécia", en: "Greece" },
  { code: "gl", pt: "Gronelândia", en: "Greenland" },
  { code: "gp", pt: "Guadalupe", en: "Guadeloupe" },
  { code: "gu", pt: "Guam", en: "Guam" },
  { code: "gt", pt: "Guatemala", en: "Guatemala" },
  { code: "gy", pt: "Guiana", en: "Guyana" },
  { code: "gn", pt: "Guiné", en: "Guinea" },
  { code: "gw", pt: "Guiné-Bissau", en: "Guinea-Bissau" },
  { code: "gq", pt: "Guiné Equatorial", en: "Equatorial Guinea" },
  { code: "ht", pt: "Haiti", en: "Haiti" },
  { code: "nl", pt: "Países Baixos", en: "Netherlands" },
  { code: "hn", pt: "Honduras", en: "Honduras" },
  { code: "hk", pt: "Hong Kong", en: "Hong Kong" },
  { code: "hu", pt: "Hungria", en: "Hungary" },
  { code: "ye", pt: "Iémen", en: "Yemen" },
  { code: "in", pt: "Índia", en: "India" },
  { code: "id", pt: "Indonésia", en: "Indonesia" },
  { code: "ir", pt: "Irão", en: "Iran" },
  { code: "iq", pt: "Iraque", en: "Iraq" },
  { code: "ie", pt: "Irlanda", en: "Ireland" },
  { code: "is", pt: "Islândia", en: "Iceland" },
  { code: "il", pt: "Israel", en: "Israel" },
  { code: "it", pt: "Itália", en: "Italy" },
  { code: "jm", pt: "Jamaica", en: "Jamaica" },
  { code: "jp", pt: "Japão", en: "Japan" },
  { code: "jo", pt: "Jordânia", en: "Jordan" },
  { code: "kw", pt: "Kuwait", en: "Kuwait" },
  { code: "la", pt: "Laos", en: "Laos" },
  { code: "ls", pt: "Lesoto", en: "Lesotho" },
  { code: "lv", pt: "Letónia", en: "Latvia" },
  { code: "lb", pt: "Líbano", en: "Lebanon" },
  { code: "lr", pt: "Libéria", en: "Liberia" },
  { code: "ly", pt: "Líbia", en: "Libya" },
  { code: "li", pt: "Listenstaine", en: "Liechtenstein" },
  { code: "lt", pt: "Lituânia", en: "Lithuania" },
  { code: "lu", pt: "Luxemburgo", en: "Luxembourg" },
  { code: "mo", pt: "Macau", en: "Macau" },
  { code: "mk", pt: "Macedónia do Norte", en: "North Macedonia" },
  { code: "mg", pt: "Madagáscar", en: "Madagascar" },
  { code: "my", pt: "Malásia", en: "Malaysia" },
  { code: "mw", pt: "Malávi", en: "Malawi" },
  { code: "mv", pt: "Maldivas", en: "Maldives" },
  { code: "ml", pt: "Mali", en: "Mali" },
  { code: "mt", pt: "Malta", en: "Malta" },
  { code: "ma", pt: "Marrocos", en: "Morocco" },
  { code: "mq", pt: "Martinica", en: "Martinique" },
  { code: "mu", pt: "Maurícia", en: "Mauritius" },
  { code: "mr", pt: "Mauritânia", en: "Mauritania" },
  { code: "mx", pt: "México", en: "Mexico" },
  { code: "mm", pt: "Mianmar", en: "Myanmar" },
  { code: "fm", pt: "Micronésia", en: "Micronesia" },
  { code: "mz", pt: "Moçambique", en: "Mozambique" },
  { code: "md", pt: "Moldávia", en: "Moldova" },
  { code: "mc", pt: "Mónaco", en: "Monaco" },
  { code: "mn", pt: "Mongólia", en: "Mongolia" },
  { code: "me", pt: "Montenegro", en: "Montenegro" },
  { code: "na", pt: "Namíbia", en: "Namibia" },
  { code: "np", pt: "Nepal", en: "Nepal" },
  { code: "ni", pt: "Nicarágua", en: "Nicaragua" },
  { code: "ne", pt: "Níger", en: "Niger" },
  { code: "ng", pt: "Nigéria", en: "Nigeria" },
  { code: "no", pt: "Noruega", en: "Norway" },
  { code: "nz", pt: "Nova Zelândia", en: "New Zealand" },
  { code: "om", pt: "Omã", en: "Oman" },
  { code: "pk", pt: "Paquistão", en: "Pakistan" },
  { code: "pw", pt: "Palau", en: "Palau" },
  { code: "ps", pt: "Palestina", en: "Palestine" },
  { code: "pa", pt: "Panamá", en: "Panama" },
  { code: "pg", pt: "Papua-Nova Guiné", en: "Papua New Guinea" },
  { code: "py", pt: "Paraguai", en: "Paraguay" },
  { code: "pe", pt: "Peru", en: "Peru" },
  { code: "pf", pt: "Polinésia Francesa", en: "French Polynesia" },
  { code: "pl", pt: "Polónia", en: "Poland" },
  { code: "pr", pt: "Porto Rico", en: "Puerto Rico" },
  { code: "pt", pt: "Portugal", en: "Portugal" },
  { code: "ke", pt: "Quénia", en: "Kenya" },
  { code: "kg", pt: "Quirguistão", en: "Kyrgyzstan" },
  { code: "gb", pt: "Reino Unido", en: "United Kingdom" },
  { code: "cf", pt: "República Centro-Africana", en: "Central African Republic" },
  { code: "do", pt: "República Dominicana", en: "Dominican Republic" },
  { code: "cz", pt: "República Checa", en: "Czechia" },
  { code: "ro", pt: "Roménia", en: "Romania" },
  { code: "rw", pt: "Ruanda", en: "Rwanda" },
  { code: "ru", pt: "Rússia", en: "Russia" },
  { code: "ws", pt: "Samoa", en: "Samoa" },
  { code: "sm", pt: "São Marino", en: "San Marino" },
  { code: "st", pt: "São Tomé e Príncipe", en: "São Tomé and Príncipe" },
  { code: "sn", pt: "Senegal", en: "Senegal" },
  { code: "sl", pt: "Serra Leoa", en: "Sierra Leone" },
  { code: "rs", pt: "Sérvia", en: "Serbia" },
  { code: "sc", pt: "Seicheles", en: "Seychelles" },
  { code: "sg", pt: "Singapura", en: "Singapore" },
  { code: "sy", pt: "Síria", en: "Syria" },
  { code: "so", pt: "Somália", en: "Somalia" },
  { code: "lk", pt: "Sri Lanka", en: "Sri Lanka" },
  { code: "sd", pt: "Sudão", en: "Sudan" },
  { code: "ss", pt: "Sudão do Sul", en: "South Sudan" },
  { code: "se", pt: "Suécia", en: "Sweden" },
  { code: "ch", pt: "Suíça", en: "Switzerland" },
  { code: "sr", pt: "Suriname", en: "Suriname" },
  { code: "th", pt: "Tailândia", en: "Thailand" },
  { code: "tw", pt: "Taiwan", en: "Taiwan" },
  { code: "tz", pt: "Tanzânia", en: "Tanzania" },
  { code: "tj", pt: "Tajiquistão", en: "Tajikistan" },
  { code: "tl", pt: "Timor-Leste", en: "Timor-Leste" },
  { code: "tg", pt: "Togo", en: "Togo" },
  { code: "to", pt: "Tonga", en: "Tonga" },
  { code: "tt", pt: "Trindade e Tobago", en: "Trinidad and Tobago" },
  { code: "tn", pt: "Tunísia", en: "Tunisia" },
  { code: "tm", pt: "Turcomenistão", en: "Turkmenistan" },
  { code: "tr", pt: "Turquia", en: "Turkey" },
  { code: "ua", pt: "Ucrânia", en: "Ukraine" },
  { code: "ug", pt: "Uganda", en: "Uganda" },
  { code: "uy", pt: "Uruguai", en: "Uruguay" },
  { code: "uz", pt: "Usbequistão", en: "Uzbekistan" },
  { code: "vu", pt: "Vanuatu", en: "Vanuatu" },
  { code: "va", pt: "Vaticano", en: "Vatican City" },
  { code: "ve", pt: "Venezuela", en: "Venezuela" },
  { code: "vn", pt: "Vietname", en: "Vietnam" },
  { code: "zm", pt: "Zâmbia", en: "Zambia" },
  { code: "zw", pt: "Zimbabué", en: "Zimbabwe" },
];

// Sorted alphabetically by PT name (default UI language). Default = first item.
export const COUNTRIES = [...RAW].sort((a, b) => a.pt.localeCompare(b.pt, "pt"));

const BY_CODE = COUNTRIES.reduce((acc, c) => { acc[c.code] = c; return acc; }, {});

export const DEFAULT_COUNTRY = COUNTRIES[0]?.code || "pt";

export const flagUrl = (code) => `https://flagcdn.com/24x18/${(code || "").toLowerCase()}.png`;

export const countryName = (code, lang = "pt") => {
  const c = BY_CODE[(code || "").toLowerCase()];
  if (!c) return "";
  return lang === "en" ? c.en : c.pt;
};
